import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { CloseButton } from './CloseButton';
import { ConsentContent } from './ConsentContent';
import { ConsentActions } from './ConsentActions';

export function ConsentModal({ onAccept, onClose }) {
  const { t } = useTranslation();
  
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" role="dialog">
      <div className="flex items-center justify-center min-h-screen">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75" />
        
        <div className="relative bg-white rounded-lg max-w-2xl w-full">
          <CloseButton onClose={onClose} />
          <ConsentContent />
          <ConsentActions onAccept={onAccept} onClose={onClose} />
        </div>
      </div>
    </div>
  );
} 